import { useTranslation } from "react-i18next";
import Investments from "../CompanyDetail/Investments";
const InvestmentsContainer = () => {
    const {t} = useTranslation()
    return ( <div className="company__body__items">
    <div className="companydetail__info__label">
        <h6>
            {t('Investments')}
        </h6>
    </div>
    <div className="company__component__country">
        <Investments/>
    </div>
    </div> );
}
 

export default InvestmentsContainer;